// Centralized content & assets for Mecana EcoHotel

export const HOTEL = {
  name: "Mecana EcoHotel",
  tagline:
    "Set within the tropical rain forests at a private nature reserve and edged by virgin shores",
  location: "Playa Mecana, Bahía Solano, Chocó — Colombia",
  phone: "+57 320 6869523",
  phoneDigits: "573206869523",
  email: "jardinpacificosas@gmail.com",
  instagram: "mecanaecohotel",
  instagramUrl: "https://instagram.com/mecanaecohotel",
  website: "https://jbdp.org",
  logo:
    "https://customer-assets.emergentagent.com/job_3f6e741b-5287-4458-b0bf-7944c353526c/artifacts/ummns6yy_mecana.jpg",
};

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1620792815254-bce6d49123d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMHJhaW5mb3Jlc3QlMjBiZWFjaHxlbnwwfHx8fDE3ODI4MzY3NDh8MA&ixlib=rb-4.1.0&q=85",
  aboutBeach:
    "https://images.unsplash.com/photo-1579683670728-96c9abc7a088?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzZWNsdWRlZCUyMGp1bmdsZSUyMGJlYWNoJTIwcGFsbSUyMHRyZWVzfGVufDB8fHx8MTc4MjgzNjgxOXww&ixlib=rb-4.1.0&q=85",
  aboutForest:
    "https://images.unsplash.com/photo-1668486114798-65438c9c4e19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMHJhaW5mb3Jlc3QlMjBiZWFjaHxlbnwwfHx8fDE3ODI4MzY3NDh8MA&ixlib=rb-4.1.0&q=85",
};

export const ROOMS = [
  {
    id: "rainforest-bungalow",
    name: "Rainforest Bungalow",
    desc:
      "A handcrafted wooden bungalow tucked beneath the jungle canopy, with a private terrace where the forest is your only neighbour.",
    capacity: "2 guests",
    features: ["Canopy terrace", "Hammock & rocking chairs", "Ensuite bathroom", "Natural cross-ventilation"],
    image:
      "https://images.unsplash.com/photo-1772703003096-fe4096559f81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxlY28lMjBsb2RnZSUyMHdvb2RlbiUyMGNhYmluJTIwanVuZ2xlfGVufDB8fHx8MTc4MjgzNjgxMnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ocean-view-suite",
    name: "Ocean-View Suite",
    desc:
      "An elevated retreat opening toward Playa Mecana, where mornings begin with the sound of the Pacific and the call of tropical birds.",
    capacity: "2–3 guests",
    features: ["Panoramic deck", "King bed & daybed", "Outdoor lounge", "Sunset orientation"],
    image:
      "https://images.unsplash.com/photo-1777913319909-1d27d36db93e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxlY28lMjBsb2RnZSUyMHdvb2RlbiUyMGNhYmluJTIwanVuZ2xlfGVufDB8fHx8MTc4MjgzNjgxMnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "family-lodge",
    name: "Family Reserve Lodge",
    desc:
      "A spacious thatched lodge designed for families and small groups, surrounded by gardens and steps from the mangrove trails.",
    capacity: "Up to 4 guests",
    features: ["Two bedrooms", "Shaded porch", "Garden access", "Mangrove trail nearby"],
    image:
      "https://images.unsplash.com/photo-1754078219069-7565df2033b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxlY28lMjBsb2RnZSUyMHdvb2RlbiUyMGNhYmluJTIwanVuZ2xlfGVufDB8fHx8MTc4MjgzNjgxMnww&ixlib=rb-4.1.0&q=85",
  },
];

export const EXPERIENCES = [
  {
    id: "whale-watching",
    title: "Whale Watching",
    season: "Jul – Oct",
    desc:
      "Witness humpback whales as they migrate to the warm waters of the Colombian Pacific to breed and raise their calves.",
    image:
      "https://images.pexels.com/photos/14834819/pexels-photo-14834819.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "rainforest-hikes",
    title: "Rainforest Hikes",
    season: "Year-round",
    desc:
      "Walk guided trails through one of the most biodiverse forests on Earth, reaching hidden freshwater waterfalls.",
    image:
      "https://images.unsplash.com/photo-1519830103773-4bdc5166a0db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMHJhaW5mb3Jlc3QlMjB3YXRlcmZhbGwlMjBoaWtpbmd8ZW58MHx8fHwxNzgyNTExNzM1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "mangrove-tours",
    title: "Mangrove & River Tours",
    season: "Year-round",
    desc:
      "Glide through ancient mangrove channels by canoe, spotting birds, crabs and the quiet pulse of the estuary.",
    image:
      "https://images.unsplash.com/photo-1609872231367-2dae230b4aff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMHJhaW5mb3Jlc3QlMjB3YXRlcmZhbGwlMjBoaWtpbmd8ZW58MHx8fHwxNzgyNTExNzM1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "virgin-beaches",
    title: "Virgin Beaches",
    season: "Year-round",
    desc:
      "Spend slow days on untouched black-and-gold sand shores, with nothing between you and the open Pacific.",
    image:
      "https://images.unsplash.com/photo-1781436187343-dfdbd6cda428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxzZWNsdWRlZCUyMGp1bmdsZSUyMGJlYWNoJTIwcGFsbSUyMHRyZWVzfGVufDB8fHx8MTc4MjgzNjgxOXww&ixlib=rb-4.1.0&q=85",
  },
];

export const GALLERY = [
  {
    src:
      "https://images.unsplash.com/photo-1711151700453-ed1e42bba3ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMHJhaW5mb3Jlc3QlMjBiZWFjaHxlbnwwfHx8fDE3ODI4MzY3NDh8MA&ixlib=rb-4.1.0&q=85",
    alt: "Calm waters edged by rainforest",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src:
      "https://images.unsplash.com/photo-1518399681705-1c1a55e5e883?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx3aGFsZSUyMHdhdGNoaW5nJTIwb2NlYW58ZW58MHx8fHwxNzgyODM2NzQ4fDA&ixlib=rb-4.1.0&q=85",
    alt: "Humpback whales surfacing",
    span: "",
  },
  {
    src:
      "https://images.unsplash.com/photo-1611223157162-e4cb1419a7d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMHJhaW5mb3Jlc3QlMjB3YXRlcmZhbGwlMjBoaWtpbmd8ZW58MHx8fHwxNzgyNTExNzM1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Forest waterfall in the distance",
    span: "",
  },
  {
    src:
      "https://images.unsplash.com/photo-1579683670728-96c9abc7a088?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzZWNsdWRlZCUyMGp1bmdsZSUyMGJlYWNoJTIwcGFsbSUyMHRyZWVzfGVufDB8fHx8MTc4MjgzNjgxOXww&ixlib=rb-4.1.0&q=85",
    alt: "Aerial view of jungle meeting the sea",
    span: "lg:col-span-2",
  },
  {
    src:
      "https://images.unsplash.com/photo-1777913319909-1d27d36db93e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxlY28lMjBsb2RnZSUyMHdvb2RlbiUyMGNhYmluJTIwanVuZ2xlfGVufDB8fHx8MTc4MjgzNjgxMnww&ixlib=rb-4.1.0&q=85",
    alt: "Open-air lodge overlooking greenery",
    span: "",
  },
  {
    src:
      "https://images.unsplash.com/photo-1656156532668-37959bee160f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxzZWNsdWRlZCUyMGp1bmdsZSUyMGJlYWNoJTIwcGFsbSUyMHRyZWVzfGVufDB8fHx8MTc4MjgzNjgxOXww&ixlib=rb-4.1.0&q=85",
    alt: "Secluded beach beneath forested hills",
    span: "",
  },
];
